;(function(){
  
  var batSelector = {
    productThumb: '#ProductThumbs li'
  };
  
  var productThumbClickHandler = function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
  }

  $(document).on('click', batSelector.productThumb, productThumbClickHandler);
})(jQuery);

/**
  * Tabs functionality:
  * Buttons must have class "kh-tabs-button".
  * Tabs contents must have class "kh-tabs-content".
  * For grouping, use a parent with the same "rel" attribute.
  * Active tab or button recieve class "active", use it for styling.
  */
;(function($){
  var selector = {
    tabContent: '.kh-tabs-content',
    tabButton: '.kh-tabs-button',
    tabArrow: '.kh-tabs-arrows'
  };

  var khTabButtonClickHandler = function(){
    var index = $(this).index();
    var rel = $(this).parents('[rel]').eq(0).attr('rel');
    var parent = $('body');
    if (typeof rel !== 'undefined') parent = parent.find('[rel="'+rel+'"]');
    parent.find(selector.tabButton).filter('.active').removeClass('active');
    parent.find(selector.tabButton).parent().each(function(wrapIndex, wrap){
      $(wrap).find(selector.tabButton).eq(index).addClass('active');
    });    
    parent.find(selector.tabContent).filter('.active').removeClass('active');
    parent.find(selector.tabContent).parent().each(function(wrapIndex, wrap){
      $(wrap).find(selector.tabContent).eq(index).addClass('active');
    });
    // Remember the data-hash in the browser address
    var hash = $(this).data('hash');
    if (typeof hash !== 'undefined') {
      if(history.pushState) {
        history.pushState(null, null, '#'+hash);
      } else {
        location.hash = '#'+hash;
      }
    };
  };
  
  var khTabButtonReadyHandler = function(){
    // Read locatio hash and turn tabs to selected
    var hash = window.location.hash;
    if (hash.indexOf('#') < 0) return;
    hash = hash.substr(1);
    $(selector.tabButton).filter('[data-hash="'+hash+'"]').click();
  };
  
  var khTabArrowClickHandler = function(e){
    e.preventDefault();
    var rel = $(this).parents('[rel]').eq(0).attr('rel');
    var parent = $('body');
    if (typeof rel !== 'undefined') parent = parent.find('[rel="'+rel+'"]');
    var index = parent.find(selector.tabButton).filter('.active').index();
    var count = parent.find(selector.tabButton).length;
    if ($(this).hasClass('left')) {
      if (--index < 0) index = count - 1;
    } else {
      if (++index >= count) index = 0;
    };
    parent.find(selector.tabButton).eq(index).click();
  };

  $(document)
  	.on('click', selector.tabButton, khTabButtonClickHandler)
  	.on('click', selector.tabArrow, khTabArrowClickHandler)
  	.on('ready', khTabButtonReadyHandler);
})(jQuery);

/**
  * Countdoun timer functionality
  */

;(function(){
  
  var deadline = 'October 27 2017 23:59:59 GMT-04:00';
  
  function getTimeRemaining(endtime){
    var t = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor( (t/1000) % 60 );
    var minutes = Math.floor( (t/1000/60) % 60 );
    var hours = Math.floor( (t/(1000*60*60)) % 24 );
    var days = Math.floor( t/(1000*60*60*24) );
    return {
     'total': t,
     'days': days,
     'hours': hours,
     'minutes': minutes,
     'seconds': seconds
    };
  };
  
  function addZero(value) {
    return value >= 10 ? value : '0'+value;
  }
  
  var deadlineIntervalCheckFunction = function(){
    var time = getTimeRemaining(deadline);
    if (!time.total) {
      $('.countdown').remove();
      clearInterval(deadlineInterval);
      return;
    };
    $('.countdown-value').eq(0).find('.countdown-value-digits').text(time.days);
    $('.countdown-value').eq(1).find('.countdown-value-digits').text(addZero(time.hours));
    $('.countdown-value').eq(2).find('.countdown-value-digits').text(addZero(time.minutes));
    $('.countdown-value').eq(3).find('.countdown-value-digits').text(addZero(time.seconds));
  };
  
  var deadlineInterval = setInterval(deadlineIntervalCheckFunction, 1000);
  deadlineIntervalCheckFunction();
})(jQuery);